import { memo } from "react";
import { cn } from "../../../utils/cn";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";
import AreaAccessPermitPDF from "../../inputs/AreaAccessPermitPDF";

interface ParkingAccessDetailsProps {
    permitDetails: {
        vehicleAccess: {
            s_VehicleAccess_En: string;
        }[]
        buildings: {
            s_LocationName_En: string;
            s_LocationName_Ar: string;
            items: {
                s_BuildingName_En: string;
                s_BuildingName_Ar: string;
            }[];
        }[];
    };
}

const ParkingAccessDetails = ({
    permitDetails,
}: ParkingAccessDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Parking Access Details
                </span>
            </div>

            <TextInputPermitPDF
                label="Vehicle Access:"
                value={permitDetails?.vehicleAccess.map(access => access.s_VehicleAccess_En).join(", ") || ""}
                labelStyles="border-r border-b w-[20%]"
                valueStyles="border-r border-b w-[80%]"
            />

            <AreaAccessPermitPDF buildings={permitDetails?.buildings} />
        </div>
    );
};

export default memo(ParkingAccessDetails);
